import React, { useContext, useEffect, useState } from "react";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import { AppContext } from "../../../../Context/AppContext";
import AppSettings from "../../../../Settings/AppSettings";
import LoadingSuccessErrorAlert from "./LoadingSuccessErrorAlert";

import Utils from "../../../../Common/Utils";

import Label from "../../../Common/components/Label";
import { toast } from "react-toastify";
import { uploadStatus } from "Components/GMS/Pdw/APIServices/Services";

let imageFilesArray = [];
let multipleFiles = [];

const ProductImages = ({ productID, productImages, setProductImages, setInitialDescriptionAndImages }) => {
  const { setProductImagesGlobal, setProductCount } = useContext(AppContext);
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [Loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const [urlImage, setUrlImage] = useState("");
  const [inputUrl, setInputUrl] = useState("");
  const [editPageNew, setEditPageNew] = useState(false);
  const [disableButton, setDisableButton] = useState(false);

  useEffect(() => {}, [editPageNew]);

  useEffect(() => {
    setProductImagesGlobal(productImages);
    setLoading({
      status: "",
      message: "",
    })
  }, [productImages]);

  async function addUrlImage() {

    if (inputUrl && !validURL(inputUrl)) {
      toast.error("Please enter valid image url");
      return;
    }

    if (handleImageValidation(inputUrl)) {
      let constDefault = await getImagesUrlToFile(inputUrl);
      let images = productImages.slice(0);
      images.push(constDefault);
      setProductImages(images);
      setUrlImage("");
      setInputUrl("");
    }
  }

  const handleImageValidation = async (imageURL) => {
    try {
      const response = await fetch(imageURL, { method: "HEAD" });
      if (
        response.ok &&
        response.headers.get("content-type").startsWith("image/")
      ) {
        return true;
      } else {
        toast.error("Please enter valid image url");
        return false;
      }
    } catch (error) {
      return false;
    }
  };

  const getImagesUrlToFile = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl);
      if (!response.ok) {
        console.error('Failed to fetch image');
      }
      const blob = await response.blob();
      if (blob.size > 0 && blob.type.startsWith('image/')) {
        const imageExtension = blob.type.split('/')[1];
        const fileName = Utils.generate_file_name(10);
        return new File([blob], `${fileName}.${imageExtension}`, {
          type: blob.type,
          lastModified: new Date(),
        });
      } else {
        console.error('Invalid image');
      }
    } catch (error) {
      console.error('Error converting image URL to file:', error);
      return null;
    }
  }

  const onFileUpload = async (productImages) => {
    try {
      setDisableButton(true);
      if (productID === "0") {
        setProductImagesGlobal(productImages);
        // setEditPageNew(false);
        setLoading({
          status: "Success",
          message: "images are saved",
        });
        return;
      }
  
      const formData = new FormData();
      if (productImages.length > 0) {
        productImages.map((file) => {
          formData.append("product_images", file, file.name);
          return null;
        });
        formData.append(
          "product_images_existing_count",
          productImages.length.toString()
        );
      }

      const response = await ServiceWrapper.doPost(
        `${api_base_url}product/${productID}/uploadimage`,
        formData,
        null,
        AuthManager.getGmsToken(),
        true
      );
      toast.info(response?.data?.message);
      checkUploadStatus(response?.data?.job_id, productImages);
    } catch (error) {
      console.error("onFileUpload ~ error:", error);
    }
  };

  const checkUploadStatus = async (jobId, productImages) => {
    try {
      const jobResponse = await uploadStatus(jobId);
      if (!jobResponse) {
        toast.error('Something went wrong, please try again');
        return;
      }
      if (jobResponse?.processing) {
        toast.info(jobResponse?.status);
        setTimeout(() => { checkUploadStatus(jobId); }, 2000);
        return;
      }
      if (jobResponse?.error) {
        toast.error(jobResponse?.status);
        setDisableButton(false);
        return;
      }
      toast.success(jobResponse?.message);
      setInitialDescriptionAndImages((prev) =>{ return  {...prev, images: productImages}});
      setDisableButton(false);
    } catch (error) {
      console.error(" checkUploadStatus ~ error:", error);
      setDisableButton(false);
    }
  }

  async function onMultipleChange(event) {
    let files = event.target.files;
    if (files && files.length > 0) {
      let images = productImages.slice(0);
      for (let i = 0; i < files.length; i++) {
        let file = files.item(i);
        images.push(file);
        if (isFileImage(file))
          multipleFiles.push({
            selectedFile: file,
          });
      }
      setProductImages(images);
      setUrlImage("");
    }
    setLoading({
      status: null,
      message: null,
    });
  }

  function isFileImage(file) {
    const acceptedImageTypes = ["image/gif", "image/jpeg", "image/png"];
    return file && acceptedImageTypes.includes(file["type"]);
  }

  useEffect(() => {
    if (productID !== "0") {
      load_images();
    }
  }, [productID, editPageNew]);

  async function load_images() {
    setLoading({
      status: "Loading",
      message: "Loading product images",
    });
    let res = await ServiceWrapper.doGet(
      `${api_base_url}product/${productID}/getuploadedimages`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (
        res.data.done &&
        res.data.data &&
        res.data.data.product_image_detail
      ) {
        if (res.data.data.product_image_detail !== "") {
          let final = JSON.parse(
            res.data.data.product_image_detail.replace(/'/g, '"')
          );
          if (final && final.length > 0 && final[0].JPEG_IMAGES) {
            const otherImages = final[0].JPEG_IMAGES.images;
            let constDefault = await getImagesUrlToFile(
              final[0].JPEG_IMAGES.default_image
            );
            let filesArray = [];
            filesArray.push(constDefault);
            await Promise.all(
              otherImages.map(async (elem) => {
                try {
                  const contents = await getImagesUrlToFile(elem);
                  filesArray.push(contents);
                } catch (error) {
                  console.log("error" + error);
                }
              })
            );
            setProductCount(filesArray.length);
            setProductImages(filesArray);
            setInitialDescriptionAndImages((prev) =>{
              return  {...prev, images: filesArray}
            })
          }
          multipleFiles = [];
          imageFilesArray = [];
          setUrlImage("");
          setLoading({
            status: "Success",
            message: undefined,
          });
        } else {
          // setLoading({
          //   status: "Error",
          //   message: "Image List is Empty",
          // });
          setLoading({
            status: null,
            message: null,
          });
        }
      } else {
        setProductImages([]);
        setInitialDescriptionAndImages([]);
        setLoading({
          status: null,
          message: null,
        });
      }
    } else {
      setLoading({
        status: "Error",
        message: res.data && res.data.message ? res.data.message : "Error",
      });
    }
  }

  const handleUrlChange = (event) => {
    setInputUrl(event.target.value);
    if (event.target.value.trim() === "") setInputUrl("");
  };

  function validURL(str) {
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" +
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
        "((\\d{1,3}\\.){3}\\d{1,3}))" +
        "(:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
        "(\\?[;&a-z\\d%_.~+=-]*)?" +
        "(#[-a-z\\d_]*)?$",
      "i"
    );
    return !!pattern.test(str);
  }

  const handle_delete_image = async (index) => {
    productImages.splice(index, 1);
    setProductImages(productImages.slice(0));
  };

  async function setDefaultImage(fromIndex, toIndex) {
    let element = productImages[fromIndex];
    productImages.splice(fromIndex, 1);
    productImages.splice(toIndex, 0, element);
    setProductImages(productImages.slice(0));
    await onFileUpload(productImages);
  }

  return (
    <div className="tw-rounded tw-w-[890px] tw-ms-2.5 tw-border tw-shadow-[1px_2px_16px_0px_rgba(23,43,77,0.08)] tw-border-solid tw-border-[#EBECF0] px-3 py-3">
      <div className="tw-flex tw-justify-between tw-w-full">
        <label className="tw-text-base tw-font-semibold">Product Images</label>
          <div className="tw-flex tw-mt-1">
            {editPageNew && (
            <button disabled={disableButton} onClick={() => {
              setUrlImage("");
              onFileUpload(productImages);
            }} className="button-style">Save</button>
            )}
            <div className={"m-1"} />
            {editPageNew ? (
              <button onClick={() => {
                setUrlImage("");
                imageFilesArray.length = [];
                multipleFiles = [];
                setEditPageNew(false);
              }} className="outline-button">Cancel</button>
            
            
            ) : (
              <div className="flex gap-1">
                
                <button 
                onClick={() => {
                    setEditPageNew(true);
                  }} className="outline-button">Add Image</button>
                
                <button
                  type="button"
                  className="btn btn-light btn-sm"
                  style={{ color: "#091caa" }}
                  onClick={() => load_images(productID)}
                >
                  <i className="fa fa-sync-alt" />
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="row">
          <div
            className="pb-0 mb-0 col-10"
            style={{ overflowX: "scroll", overflowY: "hidden" }}
          >
            {productImages && productImages.length > 0 ? (
              <div
                className=" d-flex tw-gap-1 align-items-top"
                style={{ minHeight: "102px", manHeight: "102px" }}
              >
                {productImages.map((img, indx) => {
                  return (
                    <div
                      className="tw-align-items-center"
                      key={indx + img}
                      //style={{ height: "30px" }}
                    >
                      <div className="wrapper1">
                        <img
                          src={img ? URL.createObjectURL(img) : ''}
                          alt=""
                          style={{
                            width: "108px",
                            height: "108px",
                            objectFit: "cover",
                          }}
                        />

                        {editPageNew && (
                          <button
                            type="button"
                            className="pt-0 pb-0 border-0 closeButton1 btn btn-outline-danger btn-sm ps-1 pe-1"
                            onClick={async () => {
                              await handle_delete_image(indx);
                            }}
                          >
                            <i className="fas fa-times-circle" />
                          </button>
                        )}
                      </div>
                      {!editPageNew && indx !== 0 && (
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm ms-3 ps-1 pe-1 "
                          style={{ fontSize: "10px" }}
                          onClick={async () => {
                            await setDefaultImage(indx);
                          }}
                        >
                          Set as default
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              <div
                className="p-0 m-0 bg-white alert alert-light info"
                role="alert"
              >
                Images not available
              </div>
            )}
          </div>
          {editPageNew && (
            <div className="gap-2 mt-4 col-2 d-flex">
              <input
                className="bg-white border-0 shadow-none form-control custom-file-input"
                type="file"
                accept="image/png, image/gif, image/jpeg"
                id="formFile"
                multiple
                title="Choose Files"
                style={{
                  widows: 132,
                  overflow: "hidden",
                  color: "#091caa",
                  float: "right",
                }}
                onChange={onMultipleChange}
              />
            </div>
          )}
        </div>

        {editPageNew && (
          <div className="mt-0">
            <Label message="Image URL" fontSize={0.875} fontWeight="600" />
            <div className="mt-0">
              <div className="gap-2 d-flex">
                <input
                  className="form-control input-box-style"
                  style={{ fontWeight: "500", fontSize: "14px", color: "#000" }}
                  type="text"
                  value={inputUrl}
                  placeholder="Enter URL"
                  onChange={handleUrlChange}
                />

                <button
                  onClick={addUrlImage}
                  className="button-style tw-w-max">
                  Add
                </button>
              </div>
              {urlImage && (
                <img
                  className="mt-1"
                  src={urlImage}
                  alt=""
                  style={{ width: "108px", height: "108px" }}
                />
              )}
            </div>
          </div>
        )}

        <div className="mt-0 mb-3">
          <LoadingSuccessErrorAlert loading={Loading} />
        </div>
    </div>
  );
};
export default ProductImages;
